import { React, RefObject } from "react";
import {
  Form,
  Input,
  Button,
  Dialog,
  TextArea,
  Selector,
  Slider,
  Stepper,
  Switch,
  SafeArea
} from "antd-mobile";
import styles from "./Add.module.css"
import AddFilter from "./AddFilter.js"
import "./Adm.css"

const states = require("../../../utils/states.js")


const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5
}


//props.submit(gramma)  gramma 为null则取消,gramma为非null则提交
export default (props) => {
  console.warn('这里是添加Word面板')
  const onFinish = (values) => {
    if (!values.level) values.level = 1
    const word = values
    console.log('提交添加word ',word)
    props.submit(word)
  }

  const onCanceled = () => {
    props.submit(null)
  }
  const initLists = (wrap) => {
    wrap.listAdd = []
    var totalC = wrap.list.length
    for (let i = 1; i < totalC; i++) {
      let item = wrap.list[i]
      wrap.listAdd.push({ key: i - 1, name: item.name, selected: false })
    }
  }
  console.log('清空新建tag列表')
  initLists(states.wordTagWrap)
  // initLists(states.prepTagsWrap)
  // initLists(states.formTagsWrap)

  return (<div className={styles.addGramma}>
    <Form mode='card' className={styles.addForm}
      onFinish={onFinish}
      layout='horizontal'
      footer={<div style={{ display: 'flex' }}>
        <Button style={{ 'flex': 1, 'marginRight': '5px' }} size='large' onClick={onCanceled}>
          取消</Button>
        <Button style={{ 'flex': 1, 'marginLeft': '5px' }}
          type='submit' color='primary' size='large'>
          提交</Button>
      </div>
      }
    >
      <div className={styles.formList}>
        <div style={{height:'40%'}}/>
        <Form.Header>添加一条Word</Form.Header>
        <Form.Item name='kana' label='假名'>
          <Input placeholder='假名' />
        </Form.Item>
        <Form.Item name='word' label='词汇'
          rules={[{ required: true, message: '词汇不能为空' }]}>
          <Input placeholder='词汇' />
        </Form.Item>
        <Form.Item name='definition' label='解释'>
          <TextArea
            placeholder='请输入解释'
            maxLength={50}
            rows={2}
            showCount
          />
        </Form.Item>
        <Form.Item name='note' label='笔记'>
          <TextArea
            placeholder='笔记区域'
            maxLength={100}
            rows={2}
            showCount
          />
        </Form.Item>
        <Form.Item name='level' label='等级'>
          <Slider style={{ '--fill-color': 'var(--adm-color-default)' }} 
          marks={marks} ticks step={1} min={1} max={5} popover />
        </Form.Item>

        <div name='tag' label='tag' style={{ padding: '15px' }}>
          tag
          <AddFilter listShell={states.wordTagWrap} />
        </div>
        {/* <div name='prep' label='介词' style={{ padding: '15px' }}>
          介词
          <AddFilter listShell={states.prepTagsWrap} />
        </div>
        <div name='form' label='语态' style={{ padding: '15px' }}>
          语态
          <AddFilter listShell={states.formTagsWrap} />
        </div> */}
      </div>
    </Form>


  </div>)
}